import { UpdateProjectPreviewPassword } from '@/connection/projects/publish-project-preview';
import { serializeError } from '@/store/utils/serialize-error';
import toastTrigger from '@ui/toast/toast-trigger';
import { ProjectStateReducerCreator } from '../types';
import { EToastTypes } from '@ui/toast/toast.types';

const updateProjectPreviewPasswordReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (project_uuid: string, { rejectWithValue }) => {
      try {
        const result = await UpdateProjectPreviewPassword(project_uuid);
        return result;
      } catch (e) {
        return rejectWithValue(serializeError(e));
      }
    },
    {
      fulfilled: (state, action) => {
        if (action?.payload?.password && state.workingProject?.event_preview) {
          state.workingProject.event_preview.password = action.payload.password;
          state.updatingProjectPreviewPassword = false;
        }
      },
      pending: (state) => {
        state.updatingProjectPreviewPassword = true;
      },
      rejected: (state, action) => {
        state.updatingProjectPreviewPassword = false;
        console.error('Error updating project preview password', action.error);
        toastTrigger('There was a problem updating the project preview password', {
          type: EToastTypes.error,
          autoClose: 5000,
        });
      },
    }
  );
};

export default updateProjectPreviewPasswordReducer;
